/**
 * Utility function to format error messages from API responses
 * Handles both Pydantic validation errors (array) and simple error messages (string)
 * 
 * @param {Object} error - Axios error object
 * @param {string} fallbackMessage - Default message if no detail is found
 * @returns {string} - Formatted error message
 */
export const formatErrorMessage = (error, fallbackMessage = 'Ocorreu um erro') => {
  const errorDetail = error?.response?.data?.detail;
  
  // Handle Pydantic validation errors (array of error objects)
  if (Array.isArray(errorDetail)) {
    const errorMessages = errorDetail
      .map(err => {
        const field = err.loc?.slice(1).join('.') || 'campo';
        return `${field}: ${err.msg}`;
      })
      .join('; ');
    return `Erro de validação: ${errorMessages}`;
  }
  
  // Handle simple string errors
  if (typeof errorDetail === 'string') {
    return errorDetail;
  }
  
  // Fallback to default message
  return fallbackMessage;
};

/**
 * Show error toast with proper formatting
 * 
 * @param {Function} toast - Toast function from sonner
 * @param {Object} error - Axios error object
 * @param {string} fallbackMessage - Default message if no detail is found
 */
export const showErrorToast = (toast, error, fallbackMessage) => {
  const message = formatErrorMessage(error, fallbackMessage);
  toast.error(message);
};
